export const MAX_IMAGES_TO_LOAD = 12;
